import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { ToastrService } from 'ngx-toastr';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatCheckbox } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { escapeHtml } from '../../../utilities/escape-html';

@Component({
  selector: 'expanding-error',
  templateUrl: './expanding-error.component.html',
  styleUrls: ['./expanding-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, MatButton, MatCheckbox, FormsModule]
})
export class ExpandingErrorComponent {
  // == DEPENDENCIES  ====================
  private readonly clipboard = inject(Clipboard);
  private readonly toastr = inject(ToastrService);

  // == STATE  ====================
  public simpleMessage = input<string>('');
  public simpleMessageInfo = input<string | null>(null);
  public fullMessage = input<string>('');

  protected expanded = signal<boolean>(false);
  protected textWrap = signal<boolean>(false);

  // == ACTIONS ==========================
  protected toggleFullMessage(): void {
    this.expanded.set(!this.expanded());
  }

  protected copyFullMessage(): void {
    if (this.clipboard.copy(this.fullMessage())) {
      this.toastr.success("Copied full error message.");
    } else {
      this.toastr.error("Failed to copy full error message.");
    }
  }

  // == HELPERS ==========================
  protected formattedFullMessage = computed<string>(() => {
    const lines = escapeHtml(this.fullMessage()).split("\n");
    return lines.map(line => `<span>${line}</span>`).join("");
  });
}
